// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const versionInfo = {
    "version": "1.0.0",
    "hash": "91e945df",
    "commitDate": "1774964534"
};
/* tslint:enable */
